(function () {
    'use strict';

    angular.module("imApp").factory("businesscoSettingsService", ['$ihttp', function ($ihttp) {
        let service = {
            listSettingGroups: function (parms) {
                return $ihttp.post({
                    method: 234,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
